import React from "react";

const AboutHero = () => {
  return (
    <section className="relative w-full pt-36 md:pt-24  bg-[#FFFBF4] overflow-hidden">
      {/* HERO HEIGHT */}
      <div className="relative h-[240px] sm:h-[320px] md:h-[420px] lg:h-[520px] w-full">
        {/* Background Image */}
        <img
          src="https://images.unsplash.com/photo-1549144511-f099e773c147?q=80&w=2400&auto=format&fit=crop"
          alt="About Us Background"
          className="absolute inset-0 h-full w-full object-cover"
        />

        {/* Dark Overlay */}
        <div className="absolute inset-0 bg-black/35" />

        {/* Left Gargoyle Statue (overlay image) */}
        <img
          src="https://pngimg.com/uploads/gargoyle/gargoyle_PNG55.png"
          alt="Gargoyle"
          className="
            absolute left-0 top-0
            h-[220px] sm:h-[300px] md:h-[380px] lg:h-[460px]
            -translate-x-[20%] sm:-translate-x-[15%] md:-translate-x-[12%]
            object-contain
            opacity-95
            drop-shadow-[0_8px_18px_rgba(0,0,0,0.6)]
            pointer-events-none
          "
        />

        {/* Center Title */}
        <div className="absolute inset-0 flex items-center justify-center px-4 text-center">
          <div className="text-white">
            <p className="tracking-[0.35em] text-[11px] sm:text-[12px] md:text-[13px] uppercase opacity-90">
              INFO
            </p>

            <h1 className="mt-2 text-[34px] font-serif sm:text-[46px] md:text-[60px] lg:text-[72px] leading-none font-medium">
              About Me
            </h1>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutHero;
